import { render, staticRenderFns } from "./forgot-password-container.vue?vue&type=template&id=156748b6&"
import script from "./forgot-password-container.vue?vue&type=script&lang=js&"
export * from "./forgot-password-container.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports